import StakeSOL from '@/features/stake-sol/StakeSOL'
import { Page } from '@/ui-kit'

const StakeSOLPage = () => {
  return (
    <Page>
      <StakeSOL />
    </Page>
  )
}

export default StakeSOLPage
